import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';

import { HisSharedModule } from 'hisng';
import { CommonSharedModule } from 'app/fs/res/common/common-shared.module';
import { JournalEditFormComponent } from 'app/fs/res/publication/component/journal/edit/journal-edit-form.component';
import { JournalEditBasicDataComponent } from './edit/basic-data/journal-edit-basic-data.component';
import { JournalViewDetailsComponent } from 'app/fs/res/publication/component/journal/view/journal-view-details.component';
import { JournalSearchFormComponent } from 'app/fs/res/publication/component/journal/search/journal-search-form.component';
import { JournalSearchResultComponent } from 'app/fs/res/publication/component/journal/search/journal-search-result.component';
import { PublisherSharedModule } from 'app/fs/res/publication/component/publisher/publisher-shared.module';
import { IdentifierSharedModule } from 'app/fs/res/publication/component/identifier/identifier-shared.module';
import { CalendarModule } from 'primeng/calendar';
import { JournalEditBasicDataTabComponent } from './edit/journal-edit-basic-data-tab.component';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';

@NgModule( {
    imports: [
        FormsModule,
        ReactiveFormsModule,
        HisSharedModule,
        CommonModule,
        CommonSharedModule,
        RouterModule,

        // primeng
        AutoCompleteModule,
        ConfirmDialogModule,
        PanelModule,
        CalendarModule,
        TableModule,
        TabViewModule,

        // RES
        PublisherSharedModule,
        IdentifierSharedModule
    ],

    declarations: [
        JournalEditFormComponent,
        JournalEditBasicDataComponent,
        JournalViewDetailsComponent,
        JournalSearchFormComponent,
        JournalSearchResultComponent,
        JournalEditBasicDataTabComponent
    ],

    exports: [
        JournalEditFormComponent
    ]
} )

export class JournalSharedModule { }
